import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

export const Swatches = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
`;

export const PreviewRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 20px;
`;

// 3:2 — та же пропорция, в которой обложка обрезается и показывается гостю.
export const Preview = styled.div`
    position: relative;
    flex: 0 0 auto;
    width: 300px;
    max-width: 100%;
    height: 200px;
    border-radius: ${radii.preview};
    overflow: hidden;
`;

export const CoverImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

export const CoverPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: ${colors.segmentBg};
    color: ${colors.textSecondary};
`;

export const PlaceholderText = styled.span`
    font-size: 12px;
`;

export const LogoBadge = styled.div`
    position: absolute;
    top: 12px;
    left: 12px;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: ${shadows.activePill};
    color: ${colors.textSecondary};
`;

export const LogoImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1 1 220px;
    min-width: 0;
`;
